/**
 * Returns the creation date in milliseconds of an item in a MongoBD collection from the ID of this item
 * @param id ObjectId MongoDb
 */
export const getIdTimestamp = (id: string) => {
  const timestamp = id.substring(0,8)
  return new Date(parseInt(timestamp, 16)*1000)
}

/**
 * Returns a string representing the date passed as a parameter in the local date and time format
 * @param date A string that represent a valid date or an object Date
 */
export function strDatetime (date: Date | string) {
  const d = typeof date === 'string' || typeof date === 'undefined' ? new Date(date) : date
  return d.toString() !== 'Invalid Date' ? `${d.toLocaleDateString()} ${d.toLocaleTimeString().substring(0,5)}` : ''
}
